export default (params) => ({
  trigger: {
    name: 'alternative_primary_item.click_reviews_in_alternatives',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
